
export const capitalizeFL = (str) => {
    let result = '';
    if(str)
        result = str.charAt(0).toUpperCase() + str.slice(1);
    return result;
};

export const FLtoUppercase = (str) => {

};